import { ActivatedRouteSnapshot, PRIMARY_OUTLET } from '@angular/router';

const PATH_SEPARATOR = '/';
const PARAM_PREFIX = ':';
const WILDCARD_PATH = '**';

function isDynamicSegment(segment: string): boolean {
	return segment.startsWith(PARAM_PREFIX) || segment === WILDCARD_PATH;
}

function splitPath(path: string): string[] {
	return path.split(PATH_SEPARATOR).filter((segment) => segment.length > 0);
}

function parseUrl(url: string): URL | null {
	try {
		return new URL(url);
	} catch {
		return null;
	}
}

export function activatedRoutePattern(root: ActivatedRouteSnapshot): string[] {
	const pattern: string[] = [];
	let route: ActivatedRouteSnapshot | undefined = root;

	while (route) {
		const path = route.routeConfig?.path;
		if (path) {
			pattern.push(...splitPath(path));
		}
		route = route.children.find((child) => child.outlet === PRIMARY_OUTLET);
	}

	return pattern;
}

export function normalizePlausibleUrl(url: string, pattern: string[]): string {
	const parsed = parseUrl(url);
	if (!parsed) {
		return url;
	}

	const segments = splitPath(parsed.pathname);
	if (segments.length !== pattern.length) {
		return url;
	}

	const staticSegments = segments.filter((_, index) => !isDynamicSegment(pattern[index]));
	if (staticSegments.length === segments.length) {
		return url;
	}

	parsed.pathname = PATH_SEPARATOR + staticSegments.join(PATH_SEPARATOR);
	return parsed.toString();
}
